import {
  Label,
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Container,

} from "reactstrap";
import DateTimePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useState, useCallback, useEffect, useRef } from "react";
import { usePagination } from "../../hooks/usePagination";
import Table from "../table/Table";
import ApiService from "../../services/apiService";
import RightIcon from "../svg/RightIcon";
import LeftIcon from "../svg/LeftButton";
import { format } from "date-fns";
import { useMemo } from "react";
import { method } from "lodash";
import { styleText } from "util";
import { color } from "highcharts";
import { useNavigate } from "react-router-dom";
import CommonCardHeader from "../../coreComponents/CommonCardHeader";
import Breadcrumbs from "../../coreComponents/breadcrumbs";
import ExportExcel from "./ExportExcel";
import { toast } from "react-toastify";

const Report = () => {
  // calling report api
  const [isAction, setIsAction] = useState<boolean>();
  const [fromDateTime, setFromDateTime] = useState(null);
  const [toDateTime, setToDateTime] = useState(null);
  const [chakData, setChakData] = useState<any | []>([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [secondDropdownOpen, setSecondDropdownOpen] = useState<boolean>(false);
  const [thirdDropdownOpen, setthirdDropdownOpen] = useState<boolean>(false);
  const [selectedApi, setSelectedApi] = useState<string | null>("");
  const [isEnabled, setIsEnabled] = useState(false);
  const [selectedChakName, setSelectedChakName] = useState("");
  const [refreshKey, setRefreshKey] = useState(0);
  const [pumpingStationHistory, setPumpingStationHistory] = useState<any>();
  const [deviceType, setDeviceType] = useState<string>("");
  const [dropDownApi, setDropDownApi] = useState<string>("");
  const navigate = useNavigate();
  const [allReportData, setAllReportData] = useState<any[]>([]);
  const [hasGenerated, setHasGenerated] = useState(false);
  const noDataToastShownRef = useRef(false);

  let updatedData: any = [];

  const toggleDropdown = () => setDropdownOpen((prev) => !prev);
  const toggleSecondDropdown = () => setSecondDropdownOpen((prev) => !prev);

  useEffect(() => {
    const getChak = async () => {
      try {
        const response = await ApiService.axiosApi(`${dropDownApi}`, {
          method: "GET",
          params: {
            deviceType: deviceType.toLocaleUpperCase(),
            pageNumber: 0,
            pageSize: 0,
          },
        });
        if (response.success) {
          setChakData(response.data.data);
        } else {
          console.log(
            response.message || response.status || "unable to get chak "
          );
        }
      } catch (error) {
        console.log(error);
      }
    };

    getChak();
  }, [deviceType, setDeviceType, dropDownApi]);

  function formatDate(dateString: any) {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}`;
  }

  const {
    data,
    pageNumber,
    setPageNumber,
    pageSize,
    totalCount,
    setRefresh,
    setFromDate,
    setToDate,
    setId,
    id,
    setData,
    fromDate,
    toDate,
    loading,
  } = usePagination({
    endpoint: `/${selectedApi}`,
    refreshKey,
    enabled: isEnabled,
  });

  updatedData = useMemo(() => {
    if (!data || !Array.isArray(data)) return [];

    return data.map((time) => {
      if (selectedApi === "alarms/history") {
        return {
          ...time,
          alarmTime: time.alarmTime
            ? format(new Date(time.alarmTime), "dd-MM-yyyy HH:mm:ss")
            : "-",
          acknowledgeTime: time.acknowledgeTime
            ? format(new Date(time.acknowledgeTime), "dd-MM-yyyy HH:mm:ss")
            : "-",
          offTime: time.offTime
            ? format(new Date(time.offTime), "dd-MM-yyyy HH:mm:ss")
            : "-",
        };
      } else if (
        selectedApi === "chakhistory/getromshistory" ||
        selectedApi === "chakhistory/getdmshistory"
      ) {
        return {
          ...time,
          dateTime: time.dateTime
            ? format(new Date(time.dateTime), "dd-MM-yyyy HH:mm:ss")
            : "-",
        };
      } else if (selectedApi === "pumpingstation/history") {
        return {
          ...time,
          dateTime: time.dateTime
            ? format(new Date(time.dateTime), "dd-MM-yyyy HH:mm:ss")
            : "-",
        };
      }
      return time;
    });
  }, [data, selectedApi, refreshKey]);

  /*if(data){
   setChakHistory('')
}*/

  const totalPages = Math.ceil(totalCount / pageSize);

  const handleNext = useCallback(() => {
    setPageNumber((prev) => Math.min(totalPages, prev + 1));
  }, [setPageNumber, totalPages]);

  const handlePrev = useCallback(() => {
    setPageNumber((prev) => Math.max(1, prev - 1));
  }, [setPageNumber, totalPages]);

  const handleClick = () => {
    if (!validateGenerate()) return;

    if (fromDateTime) {
      setFromDate(formatDate(fromDateTime));
    }
    if (toDateTime) {
      setToDate(formatDate(toDateTime));
    }

    noDataToastShownRef.current = false;
    setIsEnabled(true); // Enable only once
    setHasGenerated(true);
    setRefreshKey((prev) => prev + 1); // Force API re-fetch
    setPageNumber(1);
  };
  useEffect(() => {
    if (
      hasGenerated &&
      !loading &&
      totalCount === 0 &&
      !noDataToastShownRef.current
    ) {
      toast.info("No data available for the selected date range");
      noDataToastShownRef.current = true; // 🔐 lock it
    }
  }, [loading, totalCount]);

  const handleAddStation = () => {
    navigate(`/pumping-history-add`);
  };

  const handleUpdateStation = (id: any) => {
    navigate(`/pumping-history-update/${id}`);
  };
  useEffect(() => {
    setData([]);

    setFromDateTime(null);
    setToDateTime(null);

    setRefreshKey((prev) => prev + 1); // trigger new fetch
  }, [selectedApi]);

  const fetchAllDataForExport = async () => {
    try {
      const response = await ApiService.axiosApi(`/${selectedApi}`, {
        method: "GET",
        params: {
          pageNumber: 0,
          pageSize: 0,
          chakId: id, // selected Chak ID
          fromDate: fromDate,
          toDate: toDate,
          // <-- fetch ALL rows
        },
      });

      if (response.success) {
        return response.data.data;
      } else {
        toast.error("Unable to fetch full report");
        return [];
      }
    } catch (error) {
      console.log(error);
      toast.error("API Error");
      return [];
    }
  };
  const validateGenerate = () => {
    if (!selectedApi) {
      toast.warning("Please select Report Type");
      return false;
    }

    if (selectedApi !== "pumpingstation/history" && !id) {
      toast.warning("Please select Chak");
      return false;
    }

    if (!fromDateTime) {
      toast.warning("Please select From Date");
      return false;
    }

    if (!toDateTime) {
      toast.warning("Please select To Date");
      return false;
    }

    if (new Date(fromDateTime) > new Date(toDateTime)) {
      toast.warning("From Date cannot be greater than To Date");
      return false;
    }

    return true;
  };

  return (
    <>
      <Breadcrumbs mainTitle={"reports"} parent={"Setting"} />
      <div className="report px-2 py-2">
        <div className="report-header d-flex justify-content-between align-items-center bg-light-primary">
          <div className="d-flex py-2 justify-content-evenly align-items-center dropdowninput-wrapper">
            <div className="mx-3 pb-2 input-border d-flex flex-row align-content-center items-center gap-3 custom-dropdown-wrapper">
              {/* First Dropdown Group */}
              <div className="d-flex flex-column dropdownone-wrapper">
                <Label> Report Type:</Label>
                <Dropdown
                  isOpen={secondDropdownOpen}
                  toggle={toggleSecondDropdown}
                  className="custom-dropdown-width"
                >
                  <DropdownToggle
                    className="custom-dropdown-toggle d-flex align-items-center justify-content-between report-dropdown"
                    style={{
                      fontWeight: 500,
                      width:'100%',
                      borderRadius: "5px",
                      padding: "8px 16px",
                    
                      height: "36px",
                       
                    }}
                    color="whitesmoke"
                  >
                    {selectedApi == "chakhistory/getromshistory"
                      ? "Roms Chak"
                      : selectedApi == "chakhistory/getdmshistory"
                      ? "Dms Chak"
                      : selectedApi == "alarms/history"
                      ? "Alarm"
                      : "select "}
                  </DropdownToggle>
                  <DropdownMenu
                    className="custom-dropdown-menu"
                    style={{
                      overflowY: "auto",
                      boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.1)",
                      borderRadius: "8px",
                      padding: "8px 0",
                    }}
                  >
                    <DropdownItem
                      onClick={() => {
                        setDropDownApi("/chack/getchakbydevicetype");
                        setSelectedApi("chakhistory/getromshistory");
                        setDeviceType("ROMS");
                      }}
                    >
                      Roms Chak
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setDropDownApi("/chack/getchakbydevicetype");
                        setSelectedApi("chakhistory/getdmshistory");
                        setDeviceType("DMS");
                      }}
                    >
                      Dms Chak
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setDropDownApi("chack");
                        setSelectedApi("alarms/history");
                      }}
                    >
                      Alarm
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </div>

              {/* Second Dropdown Group */}
              {selectedApi === "pumpingstation/history" ? (
                ""
              ) : (
                <div className="d-flex flex-column dropdowntwo-wrapper">
                  <Label>Chak Name:</Label>
                  <Dropdown
                    isOpen={dropdownOpen}
                    toggle={toggleDropdown}
                    className="custom-dropdown-width"
                    
                  >
                    <DropdownToggle
                      className="custom-dropdown-toggle d-flex align-items-center justify-content-between report-dropdown"
                      style={{
                        fontWeight: 500,
                        borderRadius: "5px",
                        padding: "8px 16px",
                        height: "36px",
                        width:'100%'
                    
                      }}
                      color="whitesmoke"
                    >
                      {selectedChakName ? selectedChakName : "Select "}
                    </DropdownToggle>
                    <DropdownMenu
                      className="custom-dropdown-menu"
                      style={{
                        boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.1)",
                        borderRadius: "8px",
                        padding: "8px 0",
                      }}
                    >
                      {chakData.map((data: any) => (
                        <DropdownItem
                          onClick={() => {
                            setId(data.id);
                            setSelectedChakName(data.chackName);
                          }}
                          key={data.id}
                        >
                          {data.chackName}
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  </Dropdown>
                </div>
              )}
            </div>

            <div className="mx-4 input-border pb-2 d-flex flex-column report-datetime-input">
              <Label>From Date:</Label>
              <DateTimePicker
                className="report-input"
                dateFormat="dd/MM/yyyy HH:mm:ss"
                placeholderText="DD-MM-YYYY"
                showTimeSelect
                onChange={(date: any) => setFromDateTime(date)}
                selected={fromDateTime}
                isClearable
                timeFormat="HH:mm:ss"
              />
            </div>
            <div className="mx-4  input-border pb-2 d-flex flex-column report-datetime-input">
              <Label>To Date:</Label>
              <DateTimePicker
                className="report-input"
                dateFormat="dd/MM/yyyy HH:mm:ss"
                placeholderText="DD-MM-YYYY"
                showTimeSelect
                onChange={(date: any) => setToDateTime(date)}
                selected={toDateTime}
                isClearable
                timeFormat="HH:mm:ss"
              />
            </div>
          </div>

          <div className="buttonclass d-flex justify-content-end py-2 gap-5" >
             <div className="d-flex flex-column pb-2" style={{width:'20%'}}>
            <Label style={{ visibility: "hidden" }}>Generate</Label>
            <Button
              className="px-0"
              color="success"
              onClick={handleClick}
              style={{
                 width:'100%', whiteSpace: 'nowrap',
                 overflow: 'hidden',
                 textOverflow: 'ellipsis' 
              }}
            >

                 Generate

            </Button>
            </div>

              <div className="d-flex flex-column pb-2" style={{width:'20%'}}>
              <Label style={{ visibility: "hidden" }}>Generate</Label>
            <ExportExcel
              getData={fetchAllDataForExport}
              fileName={
                selectedApi === "chakhistory/getromshistory"
                  ? "Roms_History"
                  : selectedApi === "chakhistory/getdmshistory"
                  ? "Dms_History"
                  : "Alarm_History"
              }
              columnStyle={
                selectedApi === "chakhistory"
                  ? {
                      0: { cellWidth: 70, halign: "center" },
                      1: { cellWidth: 40, halign: "center" },
                      2: { cellWidth: 30, halign: "center" },
                      3: { cellWidth: 30, halign: "center" },
                      4: { cellWidth: 30, halign: "center" },
                      5: { cellWidth: 40, halign: "center" },
                      6: { cellWidth: 60, halign: "center" },
                      7: { cellWidth: 40, halign: "center" },
                      8: { cellWidth: 40, halign: "center" },
                      9: { cellWidth: 50, halign: "center" },
                      10: { cellWidth: 50, halign: "center" },
                      11: { cellWidth: 50, halign: "center" },
                      12: { cellWidth: 50, halign: "center" },
                      13: { cellWidth: 20, halign: "center" },
                      14: { cellWidth: 20, halign: "center" },
                      15: { cellWidth: 20, halign: "center" },
                      16: { cellWidth: 20, halign: "center" },
                      17: { cellWidth: 20, halign: "center" },
                      18: { cellWidth: 20, halign: "center" },
                      19: { cellWidth: 20, halign: "center" },
                      20: { cellWidth: 20, halign: "center" },
                      21: { cellWidth: 20, halign: "center" },
                      22: { cellWidth: 20, halign: "center" },
                      23: { cellWidth: 20, halign: "center" },
                      24: { cellWidth: 20, halign: "center" },
                      25: { cellWidth: 20, halign: "center" },
                      26: { cellWidth: 20, halign: "center" },
                    }
                  : undefined
              }
              selectedChakScheme={selectedChakName}
              EffectiveFrom={fromDate}
              toDate={toDate}
              hiddenColumns={["battery", "no_Of_On_Of_Valves", "userName"]}
            />
            </div>
          </div>




        </div>

        <Table
          isAction={selectedApi === "pumpingstation/history" ? true : false}
          data={updatedData}
          columns={
            selectedApi == "chakhistory/getromshistory"
              ? [
                  { header: "DateTime", accessor: "dateTime" },
                  { header: "Chak Area", accessor: "chakArea" },
                  { header: "Chak Name", accessor: "chakName" },
                  { header: "Scheme Village", accessor: "schemeVillage" },

                  { header: "Inlet Pressure1", accessor: "pressure1" },
                  { header: "Inlet Pressure2", accessor: "pressure2" },
                  { header: "Door", accessor: "door" },

                  { header: "Temprature(°C)", accessor: "temprature" },
                  { header: "SolarVoltage(V)", accessor: "solarVoltage" },
                  { header: "Network Status", accessor: "networkStatus" },

                  {
                    header: "Pfcmd1 Discharge Pressure",
                    accessor: "pfcmd1_outpt",
                  },
                  {
                    header: "Pfcmd1 Valve Position",
                    accessor: "pfcmd1_position",
                  },
                  {
                    header: "Pfcmd1 Daily Volume",
                    accessor: "pfcmd1_dailyvolume",
                  },
                  { header: "Pfcmd1 Runtime", accessor: "pfcmd1_runtime" },

                  {
                    header: "Pfcmd2 Discharge Pressure",
                    accessor: "pfcmd2_outpt",
                  },
                  {
                    header: "Pfcmd2 Valve Position",
                    accessor: "pfcmd2_position",
                  },
                  {
                    header: "Pfcmd2 Daily Volume",
                    accessor: "pfcmd2_dailyvolume",
                  },
                  { header: "Pfcmd2 Runtime", accessor: "pfcmd2_runtime" },

                  {
                    header: "Pfcmd3 Discharge Pressure",
                    accessor: "pfcmd3_outpt",
                  },
                  {
                    header: "Pfcmd3 Valve Position",
                    accessor: "pfcmd3_position",
                  },
                  {
                    header: "Pfcmd3 Daily Volume",
                    accessor: "pfcmd3_dailyvolume",
                  },
                  { header: "Pfcmd3 Runtime", accessor: "pfcmd3_runtime" },

                  {
                    header: "Pfcmd4 Discharge Pressure",
                    accessor: "pfcmd4_outpt",
                  },
                  {
                    header: "Pfcmd4 Valve Position",
                    accessor: "pfcmd4_position",
                  },
                  {
                    header: "Pfcmd4 Daily Volume",
                    accessor: "pfcmd4_dailyvolume",
                  },
                  { header: "Pfcmd4 Runtime", accessor: "pfcmd4_runtime" },
                ]
              : selectedApi == "alarms/history"
              ? [
                  { header: "Alarm Time", accessor: "alarmTime" },
                  { header: "Chak Name", accessor: "chakName" },
                  { header: "DistrbutaryZone", accessor: "distributaryZone" },
                  { header: "SchemeVillage", accessor: "schemeVillage" },
                  {
                    header: "No. On/Of Valves",
                    accessor: "no_Of_On_Of_Valves",
                  },

                  { header: "Alarm", accessor: "alarm" },
                  { header: "Alarm OffTime", accessor: "offTime" },
                  { header: "Acknowledge By", accessor: "userName" },
                  {
                    header: "Acknowledge Remark",
                    accessor: "acknowledgeRemark",
                  },
                  { header: "Acknowledge Time", accessor: "acknowledgeTime" },
                ]
              : selectedApi == "chakhistory/getdmshistory"
              ? [
                  { header: "DateTime", accessor: "dateTime" },
                  { header: "Parent Chak", accessor: "parentChak" },
                  { header: "Chak Name", accessor: "chakName" },
                  { header: "Scheme/Village", accessor: "schemeVillage" },

                  { header: "temperature(°C)", accessor: "temprature" },
                  { header: "Solar Voltage(V)", accessor: "solarVoltage" },
                  { header: "Network Status", accessor: "networkStatus" },
                  { header: "Door", accessor: "door" },
                  { header: "Flow Rate", accessor: "flowRate" },
                  { header: "Daily Volume", accessor: "volume" },
                  { header: "Valve1", accessor: "valve1" },
                  { header: "Valve2", accessor: "valve2" },
                  { header: "Valve3", accessor: "valve3" },
                  { header: "Valve4", accessor: "valve4" },
                ]
              : [{}]
          }
          buttons={
            selectedApi === "pumpingstation/history"
              ? [
                  {
                    label: "Add",
                    onClick: handleAddStation,
                    color: "primary",
                    className: "me-2",
                  },
                  {
                    label: "Edit",
                    onClick: handleUpdateStation,
                    color: "primary",
                  },
                ]
              : []
          }
        />
        <div
          className=" d-flex justify-content-end align-content-center"
          style={{ marginRight: "10px", marginTop: "10px" }}
        >
          <p style={{ marginRight: "10px", marginTop: "8px" }}>
            Page {pageNumber} of {totalPages}
          </p>
          <button
            onClick={handlePrev}
            disabled={pageNumber === 1}
            className={`icon-button ${
              pageNumber === totalPages ? `icon-button` : ""
            }`}
          >
            <LeftIcon className="icon" />
          </button>
          <button
            className={`icon-button ${
              pageNumber === totalPages ? "disabled" : ""
            }`}
            onClick={handleNext}
            disabled={pageNumber === totalPages}
          >
            <RightIcon className="icon" />
          </button>
        </div>
      </div>
    </>
  );
};

export default Report;
